import OfferLabels from 'components/Common/Labels/OfferLabels'
import OfferBadgeTag from 'components/Common/OfferBadgeTag'
import LineEyeIcon from 'components/Luxkit/Icons/line/LineEyeIcon'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import PromotionLabel from 'components/Luxkit/Label/PromotionLabel'
import { useAppSelector } from 'hooks/reduxHooks'
import React, { ComponentProps } from 'react'
import { getOfferExtra, OFFER_VIEWS_24_HOURS_THRESHOLD } from 'selectors/offerExtraSelector'

type InheritedOfferLabelsProps = Pick<ComponentProps<typeof OfferLabels>, 'showLimitedAvailability'>

interface Props extends InheritedOfferLabelsProps {
  offer: App.Offer
  showViewsLabel?: boolean
  showBadge?: boolean
}

function OfferPageLabelGroup(props: Props) {
  const {
    offer,
    showViewsLabel,
    showBadge,
    showLimitedAvailability,
  } = props

  const offerExtra = useAppSelector(state => getOfferExtra(state, offer.id))
  const isUrgencyTodayActive = showViewsLabel && offerExtra?.viewsInLast24Hours >= OFFER_VIEWS_24_HOURS_THRESHOLD

  return <LabelGroup>
    <OfferLabels offer={offer} showLimitedAvailability={showLimitedAvailability} />
    {isUrgencyTodayActive && <PromotionLabel variant="engagement" icon={<LineEyeIcon />}>
      {offerExtra.viewsInLast24Hours.toLocaleString()} people viewed this offer today
    </PromotionLabel>}
    {showBadge && !!offer.badge && <OfferBadgeTag badge={offer.badge} />}
  </LabelGroup>
}

export default OfferPageLabelGroup
